/**
 * Constants for Price Estimator
 */

import {
  Description as DocumentIcon,
  CheckroomOutlined as ClothesIcon,
  DevicesOutlined as ElectronicsIcon,
  MenuBookOutlined as BookIcon,
  SportsEsportsOutlined as ToysIcon,
  SportsBasketballOutlined as ShoesIcon,
  LocalHospitalOutlined as MedicineIcon,
  RestaurantOutlined as FoodIcon,
  Inventory2Outlined as OtherIcon,
} from '@mui/icons-material';

// Parcel types with Material-UI icons (modern, single color)
export const PARCEL_TYPES = [
  { label: 'Documents', icon: DocumentIcon },
  { label: 'Clothes', icon: ClothesIcon },
  { label: 'Electronics', icon: ElectronicsIcon },
  { label: 'Books', icon: BookIcon },
  { label: 'Toys', icon: ToysIcon },
  { label: 'Shoes', icon: ShoesIcon },
  { label: 'Medicines', icon: MedicineIcon },
  { label: 'Food', icon: FoodIcon },
  { label: 'Other', icon: OtherIcon },
];

// Ultra-modern color palette (Uber/Rapido inspired)
export const COLORS = {
  primary: '#000000', // Black - Modern, professional
  primaryLight: '#1a1a1a', // Dark gray
  secondary: '#6b7280', // Gray 500
  accent: '#10b981', // Emerald - Success/Active
  accentLight: '#d1fae5', // Light emerald
  background: '#ffffff', // White background
  surface: '#f9fafb', // Light gray surface
  surfaceDark: '#f3f4f6', // Darker surface
  textPrimary: '#111827', // Almost black
  textSecondary: '#6b7280', // Gray
  textTertiary: '#9ca3af', // Light gray
  border: '#e5e7eb', // Light border
  borderFocus: '#000000', // Black focus
  success: '#10b981', // Emerald
  danger: '#ef4444', // Red
  white: '#ffffff',
  gradient: {
    primary: 'linear-gradient(135deg, #000000 0%, #1a1a1a 100%)',
    success: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    surface: 'linear-gradient(135deg, #f9fafb 0%, #ffffff 100%)',
  },
};
